module.exports = ".centralize-content {\n    height: 75px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = ./src/app/home/home.component.css
// module chunks = main